import { Component, OnInit, inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AppService } from '@app/app.service';
import { AnimatedTimerComponent } from '@app/shared/components/animated-timer/animated-timer.component';
import { ButtonComponent } from '@app/shared/components/button/button.component';
import { RewardBoxComponent } from '@app/shared/components/reward-box/reward-box.component';
import { LimitedTimeEvent } from '@app/shared/models/limitedTimeEvent.model';
import { Modal, ModalType, NonPersistedModalName } from '@app/shared/models/modal.model';
import { Reward } from '@app/shared/models/wallet.model';
import { AssetsService } from '@app/shared/services/assets.service';
import { SharedModule } from '@app/shared/shared.module';
import { EventsRepository } from '@app/shared/state/events/events.repository';
import { GamesRepository } from '@app/shared/state/games/games.repository';
import { GlobalDataRepository } from '@app/shared/state/global-data/global-data.repository';
import { EventManager } from '@app/shared/utils/event-manager';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'slotcom-tournaments',
  templateUrl: './tournaments.component.html',
  styleUrls: ['./tournaments.component.scss'],
  standalone: true,
  imports: [ButtonComponent, AnimatedTimerComponent, RewardBoxComponent, SharedModule],
})
export class TournamentsComponent implements OnInit {
  tournamentModalData = inject<Modal>(MAT_DIALOG_DATA);
  private eventManager = inject(EventManager);
  private eventsRepo = inject(EventsRepository);
  private translateService = inject(TranslateService);
  private assetsService = inject(AssetsService);
  private gamesRepo = inject(GamesRepository);
  private appService = inject(AppService);
  private globalDataRepo = inject(GlobalDataRepository);

  event: LimitedTimeEvent;

  lang: string;
  gameId: string;
  gameName: string;
  gameIcon: unknown;

  rewards: Reward;

  ngOnInit() {
    this.event = this.eventsRepo.getEventById(this.tournamentModalData.data.eventId);
    this.lang = this.translateService.currentLang;
    this.gameId = this.event.liveOpsStatus.challengeStatus.gameId;

    this.rewards = this.event.liveOpsStatus.challengeStatus.reward;

    if (this.gameId) {
      this.gameName = this.gamesRepo.getGameById(this.gameId)?.gameTitle;
      this.gameIcon = {
        'background-image': `url('${this.assetsService.getGameIconUrl(this.gameId)}')`,
      };
    }
  }

  handleButtonClick(): void {
    if (this.gameId && this.globalDataRepo.getCurrentGame() !== this.gameId) {
      this.appService.showGame(this.gameId);
    } else {
      this.closeModal();
    }
  }

  openInfo(): void {
    this.eventManager.openModal(new Modal(NonPersistedModalName.TournamentInfoComponent, ModalType.View, this.event));
  }

  closeModal(): void {
    this.eventManager.closeModal(new Modal(this.tournamentModalData.id, ModalType.View, this.tournamentModalData));
  }
}
